/*
 * Home: contact (sections/home-contact.liquid). Opens Calendly's popup
 * scheduler from the "Book a call" button ([data-calendly-popup], which holds
 * the scheduling URL) and from any [data-calendly-open] button on the page
 * (the hero "Book a Demo"). Landing on #book opens it too.
 *
 * Calendly's script and stylesheet load only when needed: when a booking
 * button is hovered or focused, when the card nears the viewport, or on click.
 * Without JS, or if Calendly fails to load, the buttons fall back to their
 * href (the Calendly page in a new tab, or the #book card).
 */
(function () {
  var SCRIPT = 'https://assets.calendly.com/assets/external/widget.js';
  var STYLE = 'https://assets.calendly.com/assets/external/widget.css';
  var loading = null;

  function loadCalendly() {
    if (window.Calendly) return Promise.resolve(window.Calendly);
    if (loading) return loading;
    if (!document.querySelector('link[href="' + STYLE + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = STYLE;
      document.head.appendChild(link);
    }
    loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = SCRIPT;
      s.async = true;
      s.onload = function () { resolve(window.Calendly); };
      s.onerror = function () {
        loading = null;
        reject(new Error('Calendly failed to load'));
      };
      document.head.appendChild(s);
    });
    return loading;
  }

  function schedulingUrl() {
    var el = document.querySelector('[data-calendly-popup]');
    return el ? el.getAttribute('data-url') : '';
  }

  function openPopup(fallback) {
    var url = schedulingUrl();
    if (!url) return false;
    loadCalendly().then(function (Calendly) {
      if (Calendly && Calendly.initPopupWidget) Calendly.initPopupWidget({ url: url });
      else if (fallback) fallback();
    }).catch(function () {
      if (fallback) fallback();
    });
    return true;
  }

  function init() {
    var url = schedulingUrl();
    if (!url) return;

    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-calendly-popup], [data-calendly-open]'));
    triggers.forEach(function (el) {
      el.addEventListener('mouseenter', function () { loadCalendly().catch(function () {}); }, { once: true });
      el.addEventListener('focus', function () { loadCalendly().catch(function () {}); }, { once: true });
      el.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        openPopup(function () { window.open(url, '_blank', 'noopener'); });
      });
    });

    // Warm the script up when the booking card nears the viewport.
    var card = document.querySelector('[data-calendly-popup]');
    if (card && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          io.disconnect();
          loadCalendly().catch(function () {});
        }
      }, { rootMargin: '400px 0px' });
      io.observe(card);
    }

    // Calendly's popup has no keyboard close; Escape closes it.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !document.querySelector('.calendly-overlay')) return;
      if (window.Calendly && window.Calendly.closePopupWidget) window.Calendly.closePopupWidget();
    });

    function fromHash() {
      if (window.location.hash === '#book') openPopup(null);
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
